import { commonViewTexts } from '../common';

const targetName = commonViewTexts.company;

export const companyListViewTexts = {
  title: `${targetName}一覧`,
  buttons: {
    create: `${targetName}登録`,
    edit: commonViewTexts.edit,
    delete: commonViewTexts.delete
  },
  searchBarPlaceholder: `${targetName}名`,
  header: {
    name: `${targetName}名`,
    numProjects: `${commonViewTexts.project}数`,
    numModels: `${commonViewTexts.model}数`,
    dateCreated: commonViewTexts.dateCreated,
    dateUpdated: commonViewTexts.dateUpdated
  }
} as const;
